import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  className
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center" data-id="element-1405">
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-1406" />

      <div className={cn('relative w-full sm:max-w-lg max-h-[90vh] bg-[#141414] sm:rounded-2xl rounded-t-2xl shadow-lg flex flex-col anim-slide-up border border-white/10', className)} data-id="element-1407">
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10" data-id="element-1408">
          {title ? <h2 className="text-lg font-semibold text-white" data-id="element-1409">{title}</h2> : <div data-id="element-1410" />}
          <button onClick={onClose} className="p-2 -mr-2 text-white/40 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-1411">
            <X className="w-5 h-5" data-id="element-1412" />
          </button>
        </div>

        <div className="overflow-y-auto p-6" data-id="element-1413">{children}</div>
      </div>
    </div>;
}